export default "__VITE_ASSET__D15CJfQA__"